import { createFileRoute } from '@tanstack/react-router';

import cookiePolicyHtml from '#features/static-pages/assets/cookie-policy.html?raw';
import { EmbeddedHtmlPage } from '#features/static-pages/components/EmbeddedHtmlPage';
import { legalPageOverrides } from '#features/static-pages/constants/legalPageOverrides';
import { staticPageHead } from '#features/static-pages/utils/head';
import { withLegalEnhancements } from '#features/static-pages/utils/legalEnhancements';

const title = 'Cookie Policy | Teamplay.gg';
const description =
  'Learn how Teamplay.gg uses cookies and similar technologies, and how to manage your preferences.';

export const Route = createFileRoute('/{-$locale}/_layout/cookie-policy')({
  component: CookiePolicyPage,
  head: () => staticPageHead({ title, description, pathname: '/cookie-policy' }),
});

function CookiePolicyPage() {
  const { locale } = Route.useParams();
  const localePrefix = locale === 'ru' ? '/ru' : '';
  const enhancedHtml = withLegalEnhancements(cookiePolicyHtml, {
    fallbackUpdatedAt: 'Published on Teamplay.gg',
    quickLinks: [
      { href: `${localePrefix}/privacy-policy`, label: 'Privacy Policy' },
      { href: `${localePrefix}/terms-and-conditions`, label: 'Terms' },
      { href: `${localePrefix}/cookie-policy`, label: 'Cookie Policy' },
    ],
  });

  return (
    <EmbeddedHtmlPage
      html={enhancedHtml}
      title="Cookie Policy"
      minHeight={1100}
      extraStyles={legalPageOverrides}
      runInlineScripts
      shellWidth="980px"
      showReadingProgress
      showBackToTop
      enableSectionAnchors
    />
  );
}
